import React from "react";
import Skeleton from "react-loading-skeleton";
import type { TransformedProduct } from "../../../types/productApiTypes";

interface ProductInformationProps {
  productName: string;
  description: string | null;
  variationsLoading: boolean;
  isVariable: boolean;
  isCombinationAvailable: boolean;
}

const ProductInformation: React.FC<ProductInformationProps> = ({
  productName,
  description,
  variationsLoading,
}) => {
  const isLoading = variationsLoading;

  return (
    <>
      <h1 className="product-title">{productName}</h1>

      {description && (
        <div
          className="product-description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </>
  );
};

export default ProductInformation;
